
<div class="photographer-profile sf-section">
  @if (photographer) {
    @if (photographer.image !== null) {
      <app-image
        class="photographer-profile__photo"
        [imgClass]="'photographer-profile__photo-img'"
        [src]="photographer.image!"
        [alt]="photographer.firstname || 'Photographer'"
        preset="avatar"
        aspectRatio="1/1"
        [sizes]="'124px'"
        [width]="124"
        [height]="124"
        [priority]="false"
      ></app-image>
    }

    <div class="photographer-profile__name">
      <h1>{{photographer.firstname}}</h1>
      @if (photographer.certified) {
        <div class="photographer-profile__name-certification">
          <i class="fa-solid fa-certificate"></i>
          <i class="fa-solid fa-check"></i>
        </div>
      }
    </div>

    <div class="photographer-profile__information">
      <p class="photographer-profile__location">
        <i class="fa-solid fa-location-dot"></i>
        {{ photographer.city }}
      </p>
      <span class="photographer-profile__information-separator">·</span>
      <p>
        <i class="fa-solid fa-star"></i>
        4.97
      </p>
    </div>

    <div class="photographer-profile__tags">
      @for (tagLabel of photographer.tags; track tagLabel) {
        <div class="photographer-profile__tag">
          <p>{{getTagIconFromLabel(tagLabel)}}</p>
          <p>{{('marketplace.photographer.tags.' + tagLabel)|transloco}}</p>
        </div>
      }
    </div>

    <div class="photographer-profile__description">
      <p>{{photographer.biography}}</p>
    </div>

    <div class="photographer-profile__book-now">
      <button class="button button--primary button--full-width"
        (click)="openBookNowModal()"
      >
        <p>
          {{('marketplace.photographer.book-now')|transloco}}
        </p>
        <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>
  } @else {
    <div class="photographer-profile__photo skeleton-loading"></div>
    <div class="photographer-profile__name skeleton-loading"></div>
    <div class="photographer-profile__information">
      <div class="skeleton-loading"></div>
      <span class="photographer-profile__information-separator">·</span>
      <div class="skeleton-loading"></div>
    </div>
    <div class="photographer-profile__tags">
      <div class="photographer-profile__tag skeleton-loading"></div>
      <div class="photographer-profile__tag skeleton-loading"></div>
      <div class="photographer-profile__tag skeleton-loading"></div>
      <div class="photographer-profile__tag skeleton-loading"></div>
    </div>
    <div class="photographer-profile__description">
      <div class="skeleton-loading"></div>
      <div class="skeleton-loading"></div>
      <div class="skeleton-loading"></div>
      <div class="skeleton-loading"></div>
    </div>
  }
</div>
